import React, { useMemo } from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import HKTVmallDashboards from './hktvmall/HKTVmallDashboards';
import HKTVmallIssues from './hktvmall/HKTVmallIssues';
import HKTVmallAdminAccounts from './hktvmall/HKTVmallAdminAccounts';
import HKTVmallJobAndStatus from './hktvmall/HKTVmallJobAndStatus';
import HKTVmallOrder from './hktvmall/HKTVmallOrder';
import HKTVmallProduct from './hktvmall/HKTVmallProduct';
import HKTVmallMissingSkus from './hktvmall/HKTVmallMissingSkus';

const { TabPane } = Tabs;

// 路徑與 Tab key 對應
const PATH_TO_TAB: Record<string, string> = {
  'integrations': 'hktvmall-dashboard',
  'integrations/hktvmall': 'hktvmall-dashboard',
  'integrations/hktvmall/dashboard': 'hktvmall-dashboard',
  'integrations/hktvmall/connect': 'hktvmall-connect',
  'integrations/hktvmall/issues': 'hktvmall-issues',
  'integrations/hktvmall/admin/accounts': 'hktvmall-accounts',
  'integrations/hktvmall/job': 'hktvmall-job',
  'integrations/hktvmall/order': 'hktvmall-order',
  'integrations/hktvmall/product': 'hktvmall-product',
  'integrations/hktvmall/missing-skus': 'hktvmall-missing-skus',
};

const TAB_TO_PATH: Record<string, string> = {
  'hktvmall-dashboard': 'integrations/hktvmall/dashboard',
  'hktvmall-connect': 'integrations/hktvmall/connect',
  'hktvmall-issues': 'integrations/hktvmall/issues',
  'hktvmall-accounts': 'integrations/hktvmall/admin/accounts',
  'hktvmall-job': 'integrations/hktvmall/job',
  'hktvmall-order': 'integrations/hktvmall/order',
  'hktvmall-product': 'integrations/hktvmall/product',
  'hktvmall-missing-skus': 'integrations/hktvmall/missing-skus',
};

const IntegrationsOverview: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = useMemo(() => {
    const key = PATH_TO_TAB[location.pathname.replace(/^\//, '')];
    return key || 'hktvmall-dashboard';
  }, [location.pathname]);

  const onChange = (key: string) => {
    const path = TAB_TO_PATH[key] || 'integrations/hktvmall/dashboard';
    navigate(`/${path}`);
  };

  return (
    <Tabs activeKey={activeKey} onChange={onChange}>
      <TabPane tab="HKTVmall Dashboard" key="hktvmall-dashboard">
        <HKTVmallDashboards />
      </TabPane>
      {/*<TabPane tab="HKTVmall Connect" key="hktvmall-connect">
        <HKTVmallConnect />
      </TabPane>*/}
      <TabPane tab="HKTVmall Issues" key="hktvmall-issues">
        <HKTVmallIssues />
      </TabPane>
      <TabPane tab="HKTVmall Admin Accounts" key="hktvmall-accounts">
        <HKTVmallAdminAccounts />
      </TabPane>
      <TabPane tab="HKTVmall Job & Status" key="hktvmall-job">
        <HKTVmallJobAndStatus />
      </TabPane>
      <TabPane tab="HKTVmall Order" key="hktvmall-order">
        <HKTVmallOrder />
      </TabPane>
      <TabPane tab="HKTVmall Product" key="hktvmall-product">
        <HKTVmallProduct />
      </TabPane>
      <TabPane tab="HKTVmall Missing SKUs" key="hktvmall-missing-skus">
        <HKTVmallMissingSkus />
      </TabPane>
    </Tabs>
  );
};

export default IntegrationsOverview;


